import { type DependencyList, type EffectCallback, useLayoutEffect } from 'react';

import type { EqualFunction } from './types/equal-function.type';

import { useCompareMemoize } from './hooks/compare-memoize.hook';

/**
 * A hook that works like `useLayoutEffect`, but compares dependencies using a custom equality function.
 *
 * @param effect - The effect callback to run.
 * @param dependencies - The dependencies array to compare.
 * @param equals - The equality function to use for comparing dependencies.
 */
export const useCompareLayoutEffect = (
  effect: EffectCallback,
  dependencies: DependencyList,
  equals: EqualFunction<DependencyList>
) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: the dependencies are memoized using useCompareMemoize
  useLayoutEffect(effect, useCompareMemoize(dependencies, equals));
};
